export class Strings {
    static title = "Control Valve Calculator";
    static AVK = "AVK";
    static titleProjectDescription = "Project";

    static titleInput = "Calculation input";
    static inputValveDimension = "DN-size";
    static inputValveBore = "Valve bore";
    static inputInPressure = "Upstream pressure";
    static inputOutPressure = "Downstream pressure";
    static inputFlow = "Dimensional flow";
    static inputBoreReduced = "Reduced (RB)";
    static inputBoreFull = "Full (FB)";

    static titleValveCapacityChart = "Valve characteristics chart";
    static valveCapacityDimensionalArea = "Recommended dimensional area";
    static valveCapacityCharacteristic = "Valve characteristic";
    static valveCapacityX = "% of valve capacity";
    static valveCapacityY = "Plug lift [%]";
    static valveCapacityOptimalSize = "Optimal size\n";
    static valveCapacityLabelPrefix = "DN ";

    static titleCavitationChart = "Cavitation chart";
    static cavitationChartX = "Downstream pressure [bar]";
    static cavitationChartY = "Upstream pressure [bar]";

    static titleCalculationBlock = "Calculation output";
    static calculationPressureDifference = "Differential pressure";
    static calculationFlowVelocity = "Flow velocity";
    static calculationValveKv = "Valve Kv-value";
    static calculationMinFlow = "Recommended dimensioning flow, minimum";
    static calculationMaxFlow = "Recommended maximum flow";
    static calculationCalcedKv = "Calculated Kv-Value";

    static titleCalculationMessages = "Calculation Messages";
    static calculationMessageMissingInput = "Calculation input missing";
    static calculationMessageBadPressure = "Upstream pressure must at any time be at least 0,3 bar higher than downstream pressure";
    static calculationMessageAntiCav = "Anti cav. trim or valves in series required - Consult factory";
    static calculationMessageHighFlowVel = "Flow velocity is above recommended limit, according to EN1074";
    static calculationMessageDimensionalArea = "The valve is not in the recommended dimensional area";
    static calculationMessageFullBore = "A valve with reduced bore is recommended to achieve a better regulation";
    static calculationMessageOkay = "No calculation messages";

    static titleContactBlock = "Contact information";
    static contactPhone = "Phone: ";
    static contactEmail = "E-mail: ";

    static titleProductFinder = "Show in product finder";
    static titlePrint = "Print or save calculation";

    static titleSaveCalculation = "Calculation link";
    static qrDescription = "Scan the QR code to open this calculation on your phone";
    static unitPressure = "bar";
    static unitVelocity = "m/s";
    static unitKv = "m³/hr/bar";
    static unitFlow = "m³/hr";
    static unitDimension = "[mm]";
    static buttonAccept = "Accept";
}